<span [innerHTML]="statLine"></span>
